import React from 'react';
import { useModalStore } from '@/store';
import AutoTopUpNudge from '@/components/Credits/AutoTopUpNudge';

/**
 * The standing auto top-up offer in the credit store. It only ever opens the
 * configuration screen; nothing is enabled from here.
 */
function AutoTopUpOfferRow() {
  const { closeModal } = useModalStore(state => state.actions);
  return <AutoTopUpNudge variant="row" source="credit_store" onBeforeAction={closeModal} />;
}

export default AutoTopUpOfferRow;
